import apiConfig from '@constants/apiConfig';
import useAuth from '@hooks/useAuth';
import useFetch from '@hooks/useFetch';
import { showErrorMessage, showSuccessMessage } from '@services/notifyService';
import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import ProfileForm from './ProfileForm';
import PageWrapper from '@components/PageWrapper/PageWrapper';

// Port từ license-cms/source/src/containers/account/ProfilePage.js (class -> hook).
// Dùng useFetch (ref ổn định) load cục bộ; KHÔNG dispatch getProfile toàn cục để tránh
// đua takeLatest với useAuth (ở MainLayout) -> treo/gọi lặp.
// Khung Card + PageWrapper theo chuẩn mreport-portal-site; breadcrumb 'Hồ sơ' thay cho changeBreadcrumb.
const ProfilePage = () => {
    const { profile } = useAuth();
    const { execute: executeGetProfile, loading: loadingProfile } = useFetch(apiConfig.account.getProfile, {
        immediate: false,
    });
    const { execute: executeUpdate, loading } = useFetch(apiConfig.account.updateProfile, { immediate: false });
    const [userData, setUserData] = useState({});

    // nguồn componentWillMount: getProfile({ kind: currentUser.kind })
    const loadProfile = (kind) => {
        executeGetProfile({
            params: kind !== undefined ? { kind } : undefined,
            onCompleted: (response) => {
                // nguồn getProfileData(): { ...profileData.account, ...profileData }
                if (response?.result) setUserData({ ...response.data?.account, ...response.data });
            },
        });
    };

    // componentWillMount: getProfile({ kind })
    useEffect(() => {
        loadProfile(profile?.kind);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = (valueForm) => {
        executeUpdate({
            data: { kind: userData.kind, ...valueForm },
            onCompleted: (response) => {
                // nguồn: changeUserData(...) -> làm mới hồ sơ
                loadProfile(userData.kind);
                if (response?.result === false) {
                    showErrorMessage('Cập nhật hồ sơ thất bại. Vui lòng thử lại!');
                } else {
                    showSuccessMessage('Hồ sơ của bạn đã được cập nhật!');
                }
            },
            onError: () => {
                showErrorMessage('Cập nhật hồ sơ thất bại. Vui lòng thử lại!');
            },
        });
    };

    // breadcrumb 'Hồ sơ' (nguồn: changeBreadcrumb([{ name: 'Hồ sơ' }]))
    return (
        <PageWrapper loading={loadingProfile} routes={[{ breadcrumbName: 'Hồ sơ' }]}>
            <Card style={{ minHeight: 'calc(100vh - 190px)' }}>
                {userData && Object.keys(userData).length > 0 ? (
                    <div className="profile-container">
                        <div className="profile-content">
                            <ProfileForm onSubmit={onUpdate} loading={loading} userData={userData} />
                        </div>
                    </div>
                ) : null}
            </Card>
        </PageWrapper>
    );
};

export default ProfilePage;
